export enum BeingLevelEnum {
  GovWitness = 1,
  GovRealId = 2,
  SecGovId = 3,
  WitnessConfirm = 4,
  MultiEvents = 5,
  Human = 6,
}

export interface BeingIdHistory {
  level: number;
  timestamp: string;
}

export interface BeingId {
  userId: string;
  updatedAt: string;
  level: number;
  history: BeingIdHistory[];
}